import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";
import storage from "redux-persist/lib/storage";
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";
import listenerMiddleware from "./listenerMiddleware";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import {PersistConfig} from "redux-persist/es/types";


import { userPreferenceReducer } from "../components/userPreference/userPreferenceSlice";
import { authenticationReducer } from "../components/authentication/authenticationSlice";
import { allegatiSliceReducer } from "../components/allegati/allegatiSlice";
import { utentiSliceReducer } from "components/authentication/utenti/utentiSlice";
import { ticketingSliceReducer } from "components/ticketing/ticketingSlice";
import { clientiSliceReducer } from "components/anagrafiche/clienti/clientiSlice";
import {repartiSliceReducer} from "components/anagrafiche/reparti/repartiSlice";
import {odpLegacySliceReducer} from "components/main/produzione/odpLegacySlice";
import {frazioniOdPSliceReducer} from "components/main/schedulazione/frazioniOdPSlice";
import {ostacoliSliceReducer} from "components/main/ostacoli/ostacoliSlice";
import {fasiFrazioniRepartoSliceReducer} from "components/main/reparti/fasiFrazioniRepartoSlice";
import {operatoriSliceReducer} from "components/main/personale/operatoriSlice";
import {caricoRepartiSliceReducer} from "components/main/schedulazione/caricoRepartiSlice";
import {variazioniDisponibilitaSliceReducer} from "components/main/schedulazione/variazioniDisponibilitaSlice";

const persistConfig: PersistConfig<ReturnType<typeof rootReducer>> = {
	key: "ClaireRoot",
	storage,
	stateReconciler: autoMergeLevel2,
	whitelist: [
		"userPreferenceState",
		"operatoriState",
	],
};

const rootReducer = combineReducers({
	userPreferenceState: userPreferenceReducer,
	authentication: authenticationReducer,
	allegati: allegatiSliceReducer,
	utentiState: utentiSliceReducer,
	ticketsState: ticketingSliceReducer,
	clientiState: clientiSliceReducer,
	repartiState: repartiSliceReducer,
	odpLegacyState: odpLegacySliceReducer,
	frazioniOdPState: frazioniOdPSliceReducer,
	ostacoliState: ostacoliSliceReducer,
	fasiFrazioniRepartoState: fasiFrazioniRepartoSliceReducer,
	operatoriState: operatoriSliceReducer,
	caricoRepartiState: caricoRepartiSliceReducer,
	variazioniDisponibilitaState: variazioniDisponibilitaSliceReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    // middleware: [thunk],
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>(); // Export a hook that can be reused to resolve types

export default store;
export const persistor = persistStore(store);
